<template>
  <div class="oracle-desc flex-box">
    <div class="title">Oracle Agile PLM是什么？</div>
    <!-- <div class="description">璞华PMS使制造业产品研发项目过程更透明，协同更高效、决策更准确</div> -->
    <div class="project-content">
      <div>
        <!-- （Product Lifecycle Management ，产品生命周期管理） -->
        <span>Oracle Agile PLM</span>方案套件是Oracle开发的一款覆盖产品设计、询价、制造、销售与售后服务的整个环节的产品生命周期管理软件，可以实现与ERP、SCM和CRM等各个供应链系统的协同工作。
      </div>
      <div>
        Oracle Agile PLM方案套件的宗旨是帮助企业在整个产品生命周期内加速收益，降低成本，提高质量，驱动创新，并符合法律规范。方案套件聚焦产品记录。产品记录是唯一定义产品生命周期各阶段、产品所有方面信息的复合数据集，是整个方案套件的基础。
      </div>

      <div class="hengxian"></div>
      
      <div class="">
        产品记录包括：<br/>
        ◇ 产品制造企业概念化、设计、计划、生产、销售、服务以及回收处理产品所需的各方面数据；<br/>
        ◇ 产品规划、组合绩效、设计数据库、配置变更、计划与实际成本、决策文件和问题报告；<br/>
        ◇ 企业管理产品运作的各类流程，例如变更控制流程、直接物料采购、预防与纠正措施以及合规性审计。<br/>
        总的来说，产品记录是关于产品的核心资产，如果管理得当，能显著提高企业运作效率，从而能使产品更快推向市场，提高产品获利性，并保证产品和流程符合适用规范。
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
$img: "../../assets/images";

.oracle-desc {
  padding: 8.8rem 26rem 5.4rem 25.9rem;
  flex-direction: column;
  align-items: center;
  background-color: #f0f2f5;

  .title {
    font-size: 4rem;
    font-weight: 600;
    color: #333333;
    line-height: 4rem;
    margin-bottom: 2.4rem;
  }

  .description {
    font-size: 1.8rem;
    font-weight: 400;
    color: #666A77;
    line-height: 1.8rem;
    margin-bottom: 4.2rem;
  }

  .project-content {
    width: 138rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 2.2rem;
    color: #333333;
    line-height: 3.6rem;
    text-align: left;
    font-style: normal;
    span {
      color: #FB0000;
    }
    div {
      margin-bottom: 3.6rem;
    }
    .hengxian {
      // dotted dashed
      border: 0.1rem dashed #666A77;
      opacity: 0.2;
    }
  }
}

@import "@/styles/mixins.scss";

@include mobile {
  .oracle-desc {
    padding: 4.8rem 1.6rem;
    .title {
      font-size: 2.4rem;
      line-height: 3.2rem;
      text-align: center;
    }
    .description {
      font-size: 1.4rem;
      line-height: 2.2rem;
      text-align: center;
    }
    .project-content {
      width: 100%;
      font-size: 1.5rem;
      line-height: 2.6rem;
    }
  }
}
</style>
